import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { HttpUtilsService } from './http-utils.service';
import { environment } from 'src/environments/environment';
import { Observable, catchError, map, mergeMap, of } from 'rxjs';
import { JsonConvert } from 'json2typescript';
import { Device, DeviceData, DeviceList, DeviceListData, DeviceListDataAll } from '../../models/device';
import { Paging } from '../../models/paging';
import { BooleanResp } from '../../models/boolean-resp';

@Injectable({
    providedIn: 'root'
})
export class DevicesService {
    private _url: string = `${environment.baseAPI}/devices`;

    constructor(private _http: HttpClient, private _httpUtils: HttpUtilsService) { }


    // DA RIMUOVERE
    // GETDevices(paging: Paging): Observable<DeviceList> {
    //     const mockData = {
    //         success: false,
    //         errorCode: 0,
    //         errorMessage: "",
    //         elapsed: 0,
    //         data: {
    //             count: 10,
    //             data: Array.from({ length: 10 }, (_, index) => ({
    //                 uuid: `${index + 1}`,
    //                 mac: '11:11:11:11:11:11',
    //                 name: `name_${index + 1}`,
    //                 expire: (new Date()).getTime(),
    //                 nasid: `nasid_${index + 1}`,
    //                 position: '',
    //                 enabled: true,
    //             })),
    //         }
    //     };
    //     const jsonConvert: JsonConvert = new JsonConvert();
    //     const response: DeviceListData = jsonConvert.deserializeObject(mockData, DeviceListData);
    //     return of(response.data);
    // }

    // DA ABILITARE
    GETDevices(paging:Paging){
    //     const url = `${this._url}${paging.getQs()}`;
    //     const token = "eyJhbGciOiJSUzI1NiIsInR5cCIgOiAiSldUIiwia2lkIiA6ICJ5d0cwQVY4TzRRNUVYVUdKTkFBOG5vNXREbGxwVzlWNEpJckJ6cThpeEVVIn0.eyJleHAiOjE3MDE2ODQzMDUsImlhdCI6MTcwMTY4MTMwNSwiYXV0aF90aW1lIjoxNzAxNjc3MzY4LCJqdGkiOiJjNTIxNjg2NC05ZTJkLTQ1YzItYThlNC0yMjM5ZTJhZGIyZWYiLCJpc3MiOiJodHRwczovL2F1dGguZ3VnbGllbG1vLmJpei9hdXRoL3JlYWxtcy9Jb1REZXZpY2VzTWFuYWdlbWVudCIsImF1ZCI6ImFjY291bnQiLCJzdWIiOiIzNzdkOThjZS04MDNkLTQ3ZDYtYjMzYi0zNzM5Y2Y1MjU1MzAiLCJ0eXAiOiJCZWFyZXIiLCJhenAiOiJpb3RkZXZpY2VzbWFuYWdlbWVudC1kYXNoYm9hcmQtcHVibGljIiwibm9uY2UiOiI1MDdjNWFiNS04ODQ0LTQwMWItOTNkYy00Zjg0NTQ5NzIwYmMiLCJzZXNzaW9uX3N0YXRlIjoiMDlhMWI5MmUtYTA3Zi00YzIzLThlMmYtOWEzMDI4NzUxYjM5IiwiYWNyIjoiMCIsImFsbG93ZWQtb3JpZ2lucyI6WyJodHRwOi8vbG9jYWxob3N0OjQyMDAvKiIsIioiLCJodHRwOi8vbG9jYWxob3N0LyoiLCJodHRwOi8vMTI3LjAuMC4xOjQyMDAvKiJdLCJyZWFsbV9hY2Nlc3MiOnsicm9sZXMiOlsib2ZmbGluZV9hY2Nlc3MiLCJ1bWFfYXV0aG9yaXphdGlvbiIsIkFkbWluIiwiZGVmYXVsdC1yb2xlcy1pb3RkZXZpY2VzbWFuYWdlbWVudCJdfSwicmVzb3VyY2VfYWNjZXNzIjp7ImFjY291bnQiOnsicm9sZXMiOlsibWFuYWdlLWFjY291bnQiLCJtYW5hZ2UtYWNjb3VudC1saW5rcyIsInZpZXctcHJvZmlsZSJdfX0sInNjb3BlIjoib3BlbmlkIGVtYWlsIHByb2ZpbGUiLCJzaWQiOiIwOWExYjkyZS1hMDdmLTRjMjMtOGUyZi05YTMwMjg3NTFiMzkiLCJlbWFpbF92ZXJpZmllZCI6dHJ1ZSwibmFtZSI6IkVucmljbyBHdWlkYSIsInByZWZlcnJlZF91c2VybmFtZSI6ImVucmljby5ndWlkYUBndWdsaWVsbW8uYml6IiwiZ2l2ZW5fbmFtZSI6IkVucmljbyIsImZhbWlseV9uYW1lIjoiR3VpZGEiLCJlbWFpbCI6ImVucmljby5ndWlkYUBndWdsaWVsbW8uYml6In0.T8zKq1LKlk6XTscXgvkxxhGkHZVEwYvbALCGrfYUI0nFP6w38GKaLcb3Nok8225hWWTxn3Ocmmy1usONCeS3-IycWiRayXVnjY2l8QJcvVq_5yb9oM3b3A_2-lnv2I5xRoHwRnUKbp7pZaz4ooEHoymH_04cgsHX_JOFW6opLVFi4Sj-Sl127a_bpDsWoAgNpkFmv2QuqsFGDb2XzQrgsEpjS7XlLMauTGafXgxMaYz9FFTJD4ywn5otq-0XE5LyqNAuGDw7TFlq9NJSVSxGWCR_vO84fUhr-sFO724FOijSvYenQcAsrKeIWNNbG1oVw3ovPN14sua-JGXBeWokzw";
    //     const headers = new HttpHeaders()
    //   .append('X-Consumer-Key', 'Poste')
    //   .append('Content-Type', 'application/json')
    //   .append('Authorization', `Bearer ${token}`);
    //   return this._http.get(url, { headers });

    	try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}${paging.getQs()}`, { headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: DeviceListData = jsonConvert.deserializeObject(res, DeviceListData);
                            if (response.success) {
                            	return response;
                            } else {
                            	this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    // DA RIMUOVERE
    // GETDevice(device_uuid: string): Observable<Device> {
    //     const mockData = {
    //         uuid: `1`,
    //         mac: '11:11:11:11:11:11',
    //         name: `name_1`,
    //         nasid: `nasid_1`,
    //         position: '',
    //         enabled: true,
    //     };
    //     const jsonConvert: JsonConvert = new JsonConvert();
    //     const response: Device = jsonConvert.deserializeObject(mockData, Device);
    //     return of(response);
    // }

    // DA ABILITARE
    GETDevice(device_uuid: string): Observable<Device> {
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/${device_uuid}`, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: DeviceData = jsonConvert.deserializeObject(res, DeviceData);
                            if (response.success) {
                                return response.data;
                            } else {
                                this._httpUtils.handleError(response);
                                return new Device();
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    POSTDevice(body: Device) {
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.post(`${this._url}`, JSON.stringify(body.dto()), { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: BooleanResp = jsonConvert.deserializeObject(res, BooleanResp);
                            if (response.success) {
                                return response.data;
                            } else {
                                this._httpUtils.handleError(response);
                                return false;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    POSTDeviceBulk(body: Array<Device>) {
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.post(`${this._url}/bulk`, JSON.stringify(body.map(b => b.dtoBulk())), { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: BooleanResp = jsonConvert.deserializeObject(res, BooleanResp);
                            if (response.success) {
                                return response.data;
                            } else {
                                this._httpUtils.handleError(response);
                                return false;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    PUTDevice(body: Device, device_uuid: string) {
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.put(`${this._url}/${device_uuid}`, JSON.stringify(body.dto()), { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: BooleanResp = jsonConvert.deserializeObject(res, BooleanResp);
                            if (response.success) {
                                return response.data;
                            } else {
                                this._httpUtils.handleError(response);
                                return false;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    PUTDeviceEnable(enable: any, device_uuid: string): Observable<boolean> {
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.put(`${this._url}/enable/${device_uuid}`, enable, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: BooleanResp = jsonConvert.deserializeObject(res, BooleanResp);
                            if (response.success) {
                                return response.data;
                            } else {
                                this._httpUtils.handleError(response);
                                return false;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    DELETEDevice(device_uuid: string) {
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.delete(`${this._url}/${device_uuid}`, { headers: httpHeaders }).pipe(
                        map((res: any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: BooleanResp = jsonConvert.deserializeObject(res, BooleanResp);
                            if (response.success) {
                                return response.data;
                            } else {
                                this._httpUtils.handleError(response);
                                return false;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

    GETAllDevices(){
        try {
            return this._httpUtils.getHTTPHeadersAsync().pipe(
                mergeMap(httpHeaders => {
                    return this._http.get(`${this._url}/all`, { headers: httpHeaders }).pipe(
                        map((res:any) => {
                            const jsonConvert: JsonConvert = new JsonConvert();
                            const response: DeviceListDataAll = jsonConvert.deserializeObject(res, DeviceListDataAll);
                            if (response.success) {
                            	return response;
                            } else {
                            	this._httpUtils.handleError(response);
                                return;
                            }
                        }, catchError(err => {
                            if (err.status === 401) { // Unauthorized
                                this._httpUtils.logout();
                            }
                            throw err;
                        })));
                }), catchError(err => {
                    throw err;
                })
            );
        } catch (error) {
            throw error;
        }
    }

}
